/* yy-drawer-add.js - botão "Comprar" e bolinhas de cor dos cards em lista (.product-grid-list):
   drawer "Você também vai amar", lista de coleção e vídeos.
   Usa delegação de eventos no document, por isso continua funcionando depois que o drawer é redesenhado. */
(function () {
  if (window.__yyDrawerAdd) return;
  window.__yyDrawerAdd = true;

  function money(v) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(v, window.money_format) : v;
  }
  function part(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  /* bolinha de cor: troca foto, preço e a variante que o botão vai adicionar */
  function pickColor(item) {
    var wrap = item.closest('.single-product-wrap');
    if (!wrap) return;
    var opts = wrap.querySelectorAll('.variant-option');
    for (var i = 0; i < opts.length; i++) opts[i].classList.remove('active-variant');
    var opt = item.closest('form-wrap');
    if (opt) opt.classList.add('active-variant');

    var src = item.getAttribute('dataimg');
    var img = wrap.querySelector('.product-image .img1 img');
    if (src && img) { img.setAttribute('src', src); img.setAttribute('srcset', src); }

    var price = item.getAttribute('dataprice');
    var compare = item.getAttribute('datacompare');
    var np = wrap.querySelector('.price-box .new-price');
    if (np) np.textContent = money(price);
    var op = wrap.querySelector('.price-box .old-price');
    if (op) {
      if (Number(compare) > Number(price)) { op.style.display = ''; op.innerHTML = money(compare); }
      else op.style.display = 'none';
    }

    var btn = wrap.querySelector('a.ajax-cart-btn');
    if (!btn) return;
    var m = /[?&]variant=(\d+)/.exec(item.getAttribute('dataurl') || '');
    if (m) btn.setAttribute('data-id', m[1]);
    var ok = item.getAttribute('dataavailable') !== 'false';
    var label = btn.querySelector('.cart-title');
    if (ok) {
      btn.removeAttribute('disabled');
      if (label && btn.getAttribute('data-label-add')) label.textContent = btn.getAttribute('data-label-add');
    } else {
      btn.setAttribute('disabled', '');
      if (label && btn.getAttribute('data-label-sold')) label.textContent = btn.getAttribute('data-label-sold');
    }
  }

  /* o drawer redesenhado chega sem o carrossel ligado */
  function startSwiper() {
    var el = document.querySelector('ajax-cart .drawer-slider');
    if (!el || el.classList.contains('swiper-initialized') || typeof Swiper === 'undefined') return;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: { nextEl: '.arrow-next-drawer', prevEl: '.arrow-prev-drawer' },
      autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true },
      speed: 1000
    });
  }

  function render(sections) {
    var drawer = document.getElementById('ajaxcart');
    var fresh = sections['ajax-cart'] && part(sections['ajax-cart'], '#ajaxcart');
    if (drawer && fresh) {
      drawer.innerHTML = fresh.innerHTML;
      startSwiper();
    }
    var count = sections['ajax-cart-icon'] && part(sections['ajax-cart-icon'], '.bigcounter');
    if (count) {
      var els = document.querySelectorAll('.bigcounter');
      for (var i = 0; i < els.length; i++) els[i].innerHTML = count.innerHTML;
    }
    var mini = document.querySelector('.mini-cart');
    if (mini) {
      mini.classList.remove('is-empty');
      setTimeout(function () { mini.classList.add('animate', 'active'); }, 200);
    }
  }

  /* uma única chamada ao carrinho: adiciona 1 unidade e já traz drawer e contador atualizados */
  function add(btn) {
    var id = btn.getAttribute('data-id');
    if (!id) return;
    var loader = btn.querySelector('.ajax-loader');
    btn.classList.add('loading');
    if (loader) loader.classList.remove('hidden');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'ajax-cart,ajax-cart-icon' })
    }).then(function (r) {
      return r.json();
    }).then(function (data) {
      if (!data || !data.sections) throw new Error((data && data.description) || 'cart/add');
      render(data.sections);
    }).catch(function (e) {
      console.error('yy-drawer-add:', e);
    }).then(function () {
      btn.classList.remove('loading');
      if (loader) loader.classList.add('hidden');
    });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var item = t.closest('.product-grid-list .item-data');
    if (item) { pickColor(item); return; }
    var btn = t.closest('.product-grid-list a.ajax-cart-btn');
    if (!btn) return;
    ev.preventDefault();
    if (btn.hasAttribute('disabled') || btn.classList.contains('loading')) return;
    add(btn);
  });
})();
